
import {
    GET_ALL_ACTIVE_BRANDS
   } from "../constant/ActionType";
   
   export default function AllActiveBrands(state = {
       AllActiveBrands: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_ACTIVE_BRANDS:
               return {
                   ...state,
                   AllActiveBrands: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }